import { default as initCommonDataStore } from "../../../../lib/common/js/dataStore"

function getInitialValues() {
  return {
    // Globals
    usePaymentsApi: true,
    token: null,
    measurementSystem: pipelineConfig.measurementSystem,
    domain: null,
    activeOffer: null,
    marketingAgreed: null,
    privacyAgreement: false,
    purchasedBasicOffer: null,
    skippedUpsellOffers: [],
    checkout: null,
    initiateCheckoutAt: null,
    isEmailStepCompleted: false,
    exitIntent: false,
    isExitIntentPopupShown: false,
    isPaymentLoading: false,
    segmentUserId: null,
    cookiePolicyBannerAccepted: null,

    // Specific values for the series
    goalPaceKg: 2,
    goalPaceLbs: 4,

    // Pipe form
    gender: "female",
    whyLoseWeight: null,
    howLongSinceIdealWeight: null,
    additionalGoals: [],
    yourGoal: null,
    bodyType: null,
    defineYourDiet: [],
    foodAllergies: [],
    menopause: null,
    workoutsPerWeek: null,
    badHabits: null,
    snackingTriggers: [],
    healthConditions: [],
    moodSwings: null,
    workingHours: null,
    cookingPreferences: null,
    age: null,
    heightFt: null,
    heightIn: null,
    heightCm: null,
    weightKg: null,
    weightLbs: null,
    targetWeightKg: null,
    targetWeightLbs: null,
    firstName: null,
    suddenFlushes: null,
    dryerSkin: null,
    hormonalTherapy: null,
    email: null,
  }
}

// Define data values to be used in this specific pipe variation
// and feed them to the basic data store creator fn, which is placed
// in the `lib` under current pipe series folder.
const dataStore = {
  ...initCommonDataStore({
    getInitialValues,
  }),
  
  // All variation-specific props and methods can de added or overwritten below:
  // isMetric() { },

}

export default dataStore
